import {UploadStatus} from './PhotosSection.types';

export const PENDING_STATUSES: UploadStatus[] = [
  'preview',
  'uploading',
  'error',
];

export const UPLOAD_HINT =
  'Drag and drop or tap to upload. HEIC, PNG, JPG. Up to 2 MB.';

export const ACCEPTED_FORMATS = 'HEIV, PNG, JPG';

export const MAX_SIZE = 'up to 2MB';
